import { faGripDotsVertical } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useContext } from "react"
import { SortableItemContext } from "./Sortable"


const Grabber = () => {
  const { setActivatorNodeRef, attributes, listeners } = useContext(SortableItemContext)

  return <div
    ref={setActivatorNodeRef}
    style={{ cursor: setActivatorNodeRef ? 'grab' : undefined, padding: '20px' }}
    {...attributes}
    {...listeners}
  >
    <FontAwesomeIcon icon={faGripDotsVertical} />
  </div>
}


export default Grabber
